import { Get, Patch, Post, Delete } from 'utils/axios';


/** 
 * @desc 获取试卷库目录
 * @param {object} param 
 */
export function reqGetExaminationCatalogs(params) {
  let url = '/api/v1/examination/catalogs';
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}


/** 
 * @desc 获取试卷库列表
 * @param {object} param 
 */
export function reqGetExamination(params) {
  let url = '/api/v1/examination';
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}


/** 
 * @desc 获取试卷库详情及相关资源
 * @param {object} param 
 */
export function reqGetExaminationDetail(params) {
  let url = `/api/v1/examination/${params.resourceId}`;
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}


